import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../GlobalContext';
import { Link } from 'react-router-dom';

export default function Dashboard() {
  const { auth, alert, setLoading } = useContext(GlobalContext);

  const [name, setName] = useState('');
  const [clubs, setClubs] = useState([]);
  const [create, setCreate] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/club`, {
        method: 'GET',
        headers: {
          Authorization: localStorage.getItem('auth'),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setClubs(data);
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    })()
      .catch((error) => alert({ type: 'danger', title: 'Error !', text: error.message }))
      .finally(() => setLoading(false));
  }, [alert, create, setLoading]);

  const createClub = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/club`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('auth'),
        },
        body: JSON.stringify({ name }),
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setCreate((c) => !c);
        alert({ type: 'success', title: 'Success !', text: data });
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    } catch (error) {
      alert({ type: 'danger', title: 'Error !', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const removeClub = async (cid) => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/club/${cid}`, {
        method: 'DELETE',
        headers: {
          Authorization: localStorage.getItem('auth'),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setClubs(clubs.filter((club) => club._id !== cid));
        alert({ type: 'success', title: 'Success !', text: data });
      } else {
        alert({ type: 'warning', title: 'Warning !', text: error });
      }
    } catch (error) {
      alert({ type: 'danger', title: 'Error !', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="page-body">
        <div className="container-xl d-flex flex-column justify-content-center">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Welcome {auth.name} Admin</h2>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#modal">
                  Create Club
                </button>
              </div>
            </div>
          </div>
          <div className="row row-cards mt-2">
            {clubs.map((club) => (
              <div
                key={club._id}
                className="col-md-6 col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <h3 className="card-title text-bold text-capitalize text-center">{club.name}</h3>
                  </div>
                  <div className="card-footer text-center">
                    {club.submitted ? (
                      <>
                        <h1>
                          <span className="badge bg-green">Club Submitted</span>
                        </h1>
                        <div className="mt-2">
                          <Link
                            to={`/club-teams/${club._id}`}
                            className="btn btn-primary mx-1">
                            Check Teams
                          </Link>
                        </div>
                        {/* <div className="mt-2">
                          <button
                            onClick={() => removeClub(club._id)}
                            className="btn btn-danger mx-1">
                            Delete Club
                          </button>
                        </div> */}
                      </>
                    ) : (
                      <>
                        <div className="mb-2">
                          <Link
                            to={`/club-member/${club._id}`}
                            className="btn btn-primary mx-1">
                            Edit Members
                          </Link>
                        </div>
                        {club.members.length > 0 && (
                          <div className="mb-2">
                            <Link
                              to={`/create-team/${club._id}`}
                              className="btn btn-primary mx-1">
                              Modify Teams
                            </Link>
                          </div>
                        )}
                        <div className="mb-2">
                          <button
                            onClick={() => removeClub(club._id)}
                            className="btn btn-danger mx-1">
                            Delete Club
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        id="modal"
        tabIndex="-1"
        className="modal modal-blur fade hide"
        aria-hidden="true">
        <div
          className="modal-dialog modal-dialog-centered"
          role="document">
          <form
            onSubmit={createClub}
            className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create a new club</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setName('')}
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="row mb-3 align-items-end">
                <div className="col">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="reset"
                className="btn me-auto"
                onClick={() => setName('')}
                data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                data-bs-dismiss="modal">
                Create
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
